import { Box, List, Typography } from "@mui/material";
import ListItemComponent from "./ListItem.component";

export default function OrdersMargemCard({ data }) {
  return (
    <Box
      sx={{
        backgroundColor: "#ffffff",
        boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
        padding: 2.5,
        minWidth: 250,
        borderRadius: 2,
        height: 295,
      }}
    >
      <Typography
        textAlign="left"
        fontWeight={700}
        fontSize="18px"
        color="#333"
        mb={2}
      >
        Pedidos de Venda
      </Typography>

      <List
        disablePadding
        sx={{ display: "flex", flexDirection: "column", gap: 1 }}
      >
        <ListItemComponent
          color="GRAY"
          text="Margem acima de 10%"
          value={data?.acimaDez || 0}
        />
        <ListItemComponent
          color="GREEN"
          text="Margem entre 5% e 10%"
          value={data?.entreCincoEDez || 0}
        />
        <ListItemComponent
          color="BLUE"
          text="Margem entre 0% e 5%"
          value={data?.entreZeroECinco || 0}
        />
        <ListItemComponent
          color="RED"
          text="Margem menor que 0%"
          value={data?.menorQueZero || 0}
        />
      </List>
    </Box>
  );
}
